export default __webpack_public_path__ + "static/media/toca_health_pdf_logo.ee560d27.png";